import { createSlice } from "@reduxjs/toolkit";
import { CONTENT_STEP } from "../constant";

const INITIAL_STATE = {
  content_step: CONTENT_STEP.SELECT_DISTRICT,
  currentSi: "",
  currentGu: "",
  currentTownData: {},
  currentSiVoteGraphData: [],
};
export const appSlice = createSlice({
  name: "app",
  initialState: INITIAL_STATE,
  reducers: {
    setContentStep: (state, action) => {
      state.content_step = action.payload;
    },
    setSi: (state, action) => {
      state.currentSi = action.payload;
    },
    setGu: (state, action) => {
      state.currentGu = action.payload;
    },
    setCurrentTownData: (state, action) => {
      state.currentTownData = action.payload;
    },
    setCurrentSiVoteGraphData: (state, action) => {
      state.currentSiVoteGraphData = action.payload;
    },
    resetState: () => INITIAL_STATE,
  },
});

export const {
  setContentStep,
  setSi,
  setGu,
  setCurrentTownData,
  setCurrentSiVoteGraphData,
  resetState,
} = appSlice.actions;
export const selectContentStep = (state) => state.app.content_step;
export const selectSi = (state) => state.app.currentSi;
export const selectGu = (state) => state.app.currentGu;
export const selectCurrentTownData = (state) => state.app.currentTownData;
export const selectCurrentSiVoteGraphData = (state) =>
  state.app.currentSiVoteGraphData;
export default appSlice.reducer;
